import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Pagination,
  CircularProgress,
  AppBar,
  Toolbar,
  IconButton,
  Paper,
} from "@mui/material";
import { UrlApiEnvasado } from "../../../../../../services/apirest";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import moment from "moment/moment";
import { useFechas } from "../../../../context/FechaContext";

function RankingChoferPropano() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();
  const [desde, setDesde] = useState(desdePropano);
  const [hasta, setHasta] = useState(hastaPropano);
  useEffect(() => {
    setDesdePropano(desde);
    setHastaPropano(hasta);
  }, [desde, hasta]);

  const [sucursal, setSucursal] = useState(1);
  const [rankingMenores, setRankingMenores] = useState([]);
  const [rankingMayores, setRankingMayores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageMenores, setPageMenores] = useState(1);
  const [pageMayores, setPageMayores] = useState(1);
  const rowsPerPage = 5;
  const [origenTabla, setOrigenTabla] = useState("");
  useEffect(() => {
    if (location.state.origen === "bk1_aws_hipergas") {
      setOrigenTabla("api/estadistica");
    } else if (location.state.origen === "bk1_aws_aogas") {
      setOrigenTabla("db2/api/estadisticaaogas");
    }
  }, [location.state]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch para ranking menores
      const menoresResponse = await fetch(
        `${UrlApiEnvasado}${origenTabla}/xchofer/rankingmenorespropano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.ccd_vendedor}`
      );
      const menoresData = await menoresResponse.json();
      setRankingMenores(menoresData);

      // Fetch para ranking mayores
      const mayoresResponse = await fetch(
        `${UrlApiEnvasado}${origenTabla}/xchofer/rankingmayorespropano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.ccd_vendedor}`
      );
      const mayoresData = await mayoresResponse.json();
      setRankingMayores(mayoresData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (origenTabla !== "") {
      fetchData();
    }
  }, [origenTabla]);

  const handleUpdate = () => {
    fetchData();
  };

  const handleChangePageMenores = (event, newPage) => {
    setPageMenores(newPage);
  };

  const handleChangePageMayores = (event, newPage) => {
    setPageMayores(newPage);
  };

  const handleRowClick = (row) => {
    // Redirigir a /verfactura y pasar los datos de la fila como state
    navigate("/verfactura", {
      state: {
        tipo: row.frr_tipo_comp,
        suc: row.frr_suc,
        nro: row.frr_nro,
        origen: location.state.origen,
      },
    });
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#1F618D" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  textAlign: "center",
                  pointerEvents: "none", // Evita que el título intercepte clicks
                }}
              >
            Ranking de Propano - {location.state.row.name}
          </Typography>
          <Typography
                variant="caption"
                sx={{ color: "#EAF2F8", fontStyle: "italic", marginLeft: "auto" }}
              >
                * Todos los precios están expresados sin impuestos
              </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ backgroundColor: "#fff", marginLeft: 1, marginRight: 1 }}>
        {/* Filtros */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 0, mb: 1 }}
        >
          <Grid item xs={12} md={3}>
            <TextField
              label="Desde"
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Hasta"
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              disabled={loading}
              size="medium"
              fullWidth
              sx={{
                backgroundColor: "#1F618D",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#154360",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(31, 97, 141, 0.3)",
                },
                transition: "all 0.3s ease",
                height: "40px",
                borderRadius: "8px",
              }}
              startIcon={<RefreshIcon />}
            >
              {loading ? "Cargando..." : "Actualizar"}
            </Button>
          </Grid>
        </Grid>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <CircularProgress sx={{ color: "#1F618D" }} />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {/* Tabla de Precios Mínimos */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  background:
                    "linear-gradient(135deg, #f0f9f5 0%, #e0f0ea 100%)",
                  boxShadow: "0 8px 16px rgba(46, 204, 113, 0.1)",
                  borderRadius: "12px",
                  transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                  borderLeft: "4px solid #E74C3C", // Rojo para precios mínimos
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 24px rgba(46, 204, 113, 0.2)",
                  },
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <TrendingDownIcon
                      sx={{ color: "#E74C3C", fontSize: 28, mr: 1 }}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#1F618D",
                        fontWeight: "700",
                        fontSize: "1.2rem",
                        letterSpacing: "0.5px",
                        background:
                          "linear-gradient(to right, #E74C3C, #C0392B)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      PRECIOS MÍNIMOS
                    </Typography>
                  </Box>

                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": { width: "6px", height: "6px" },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#E74C3C",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Sucursal",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#E74C3C" : "#1F618D",
                                backgroundColor: "#f0f9f5",
                                borderBottom: "2px solid #E74C3C",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rankingMenores
                          .slice(
                            (pageMenores - 1) * rowsPerPage,
                            pageMenores * rowsPerPage
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              onClick={() => handleRowClick(row)}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#ffffff",
                                },
                                "&:nth-of-type(even)": {
                                  backgroundColor: "#f0f9f5",
                                },
                                "&:hover": {
                                  backgroundColor: "#ffebee",
                                  cursor: "pointer",
                                },
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {row.name_sucursal}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "#FFEBEE",
                                    borderRadius: "4px",
                                    p: "2px 4px",
                                    display: "inline-block",
                                    fontWeight: "500",
                                  }}
                                >
                                  {row.patente}
                                </Box>
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {row.name_cliente_adi}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#E74C3C",
                                  fontSize: "0.875rem",
                                  fontWeight: "600",
                                }}
                                align={"right"}
                              >
                                ${row.precio_kilo.toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {moment(
                                  row.ccd_fecha_mov,
                                  "DD-MM-YYYY HH:mm"
                                ).format("DD/MM/YYYY HH:mm")}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                  >
                    <Pagination
                      count={Math.ceil(rankingMenores.length / rowsPerPage)}
                      page={pageMenores}
                      onChange={handleChangePageMenores}
                      color="primary"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#1F618D",
                        },
                        "& .Mui-selected": {
                          backgroundColor: "#1F618D !important",
                          color: "#fff",
                        },
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Tabla de Precios Máximos */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  background:
                    "linear-gradient(135deg, #f0f9f5 0%, #e0f0ea 100%)",
                  boxShadow: "0 8px 16px rgba(46, 204, 113, 0.1)",
                  borderRadius: "12px",
                  transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                  borderLeft: "4px solid #2ECC71", // Verde para precios máximos
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 24px rgba(46, 204, 113, 0.2)",
                  },
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <TrendingUpIcon
                      sx={{ color: "#2ECC71", fontSize: 28, mr: 1 }}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#1F618D",
                        fontWeight: "700",
                        fontSize: "1.2rem",
                        letterSpacing: "0.5px",
                        background:
                          "linear-gradient(to right, #2ECC71, #27AE60)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      PRECIOS MÁXIMOS
                    </Typography>
                  </Box>

                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": { width: "6px", height: "6px" },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#2ECC71",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Sucursal",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#2ECC71" : "#1F618D",
                                backgroundColor: "#f0f9f5",
                                borderBottom: "2px solid #2ECC71",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rankingMayores
                          .slice(
                            (pageMayores - 1) * rowsPerPage,
                            pageMayores * rowsPerPage
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              onClick={() => handleRowClick(row)}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#ffffff",
                                },
                                "&:nth-of-type(even)": {
                                  backgroundColor: "#f0f9f5",
                                },
                                "&:hover": {
                                  backgroundColor: "#e8f5e9",
                                  cursor: "pointer",
                                },
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {row.name_sucursal}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "#D5F5E3",
                                    borderRadius: "4px",
                                    p: "2px 4px",
                                    display: "inline-block",
                                    fontWeight: "500",
                                  }}
                                >
                                  {row.patente}
                                </Box>
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {row.name_cliente_adi}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#27AE60",
                                  fontSize: "0.875rem",
                                  fontWeight: "600",
                                }}
                                align={"right"}
                              >
                                ${row.precio_kilo.toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                              >
                                {moment(
                                  row.ccd_fecha_mov,
                                  "DD-MM-YYYY HH:mm"
                                ).format("DD/MM/YYYY HH:mm")}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                  >
                    <Pagination
                      count={Math.ceil(rankingMayores.length / rowsPerPage)}
                      page={pageMayores}
                      onChange={handleChangePageMayores}
                      color="primary"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#1F618D",
                        },
                        "& .Mui-selected": {
                          backgroundColor: "#1F618D !important",
                          color: "#fff",
                        },
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
}

export default RankingChoferPropano;
